import React from 'react';

const TargetList = ({ receivedTargets }) => {
  // Define colors for x, y, z values
  const xColor = 'blue';
  const yColor = 'green';
  const zColor = 'red';

  return (
    <div style={{ width: '100%' }}>
      <ul style={{ listStyleType: 'none', paddingLeft: '0', marginLeft: '10px', textAlign: 'left' }}>
        {receivedTargets.map(item => (
          <li key={item.id} style={{ textAlign: 'left', marginLeft: '0px' }}>
            {item.id} : 
            <span style={{ color: xColor }}> x </span>
            <span style={{ fontWeight: 'bold', color: xColor }}>{item.xPosCm}</span> - 
            <span style={{ color: yColor }}> y </span>
            <span style={{ fontWeight: 'bold', color: yColor }}>{item.yPosCm}</span> - 
            <span style={{ color: zColor }}> z </span>
            <span style={{ fontWeight: 'bold', color: zColor }}>{item.zPosCm}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TargetList;
